var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6585 0C12.4168 8.73591e-05 13.075 0.508786 13.2666 1.23372L14.9414 7.48372C15.2245 8.54195 14.4332 9.58333 13.3333 9.58333H9.74203L10.3581 11.2663C10.6164 11.9495 10.5497 12.7163 10.1831 13.3496L9.7168 14.1585C9.41679 14.6835 8.86657 15 8.2666 15C7.66669 15 7.13369 14.6916 6.82536 14.1667L4.42464 10C4.27468 9.74186 4.00016 9.58346 3.70036 9.58333H1.66667C0.75 9.58333 0 8.83333 0 7.91667V1.66667C0 0.75 0.75 0 1.66667 0H11.6585ZM5.625 1.65853V8.7557L8.25033 13.3252L8.7085 12.5334C8.8418 12.3167 8.85856 12.0497 8.77523 11.8164L7.75798 9.0332C7.55818 8.4916 7.96675 7.91667 8.54167 7.91667H12.242C12.7918 7.91644 13.1916 7.4 13.0501 6.86686L11.8254 2.28353L11.8164 2.27539C11.7164 1.90872 11.3833 1.65853 11.0083 1.65853H5.625ZM2.49186 1.65853C2.03353 1.65853 1.65853 2.03353 1.65853 2.49186V7.0752C1.65864 7.53344 2.03359 7.90853 2.49186 7.90853H4.10807V1.65853H2.49186Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeIconNew);
export default __webpack_public_path__ + "static/media/dislike-icon-new.2a1b92a83b680689fe6da55d03362f49.svg";
export { ForwardRef as ReactComponent };